import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { getRatio } from "../../components/column-ratio"
import { InheritedThemeProvider } from "@convertkit/editor"

const DEFAULT_IMAGE_URL =
  "https://cdn.convertkit.com/assets/placeholder-vertical.png"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-startestimonial td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }
  }
`

export function StarTestimonial({ block_id, properties }) {
  const { children } = useBlocks(block_id)
  const imageHeight = 210 // this height was taken from designs/figma

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid",
    overflow: "hidden"
  }

  const contentStyle = {
    paddingTop: properties.verticalPadding,
    paddingRight: properties.horizontalPadding,
    paddingBottom: properties.verticalPadding,
    paddingLeft: properties.horizontalPadding
  }

  return (
    <div
      className="ck-startestimonial ck-layout-block-template"
      style={containerStyle}
      bgcolor={properties.backgroundColor}
    >
      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td
              height={imageHeight}
              width={getRatio(properties.columnRatio, "left")}
              style={{
                backgroundImage: `url(${properties.image ||
                  DEFAULT_IMAGE_URL})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: properties.imageBorderRadius,
                overflow: "hidden"
              }}
            />
            <td
              width={getRatio(properties.columnRatio, "right")}
              style={{
                verticalAlign: "middle"
              }}
            >
              <div style={contentStyle}>
                <img
                  src={"https://cdn.convertkit.com/assets/images/stars.png"}
                  alt="five yellow stars"
                />
                <LiteSlateEditor block_id={children[0].block_id} />
                <InheritedThemeProvider
                  theme={{
                    paragraph: {
                      color: properties.nameColor,
                      fontFamily: properties.headingFontFamily,
                      fontSize: 16,
                      fontWeight: 700
                    }
                  }}
                >
                  <LiteSlateEditor block_id={children[1].block_id} />
                </InheritedThemeProvider>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
